<div class="font-sans">
    <section
        class="bg-[url('/assets/images/landing-page-header-bg-mobile.webp')] bg-cover bg-right bg-no-repeat py-8 md:bg-[url('/assets/images/landing-page-header-bg.webp')] md:bg-right md:py-16 lg:py-24 xl:py-32">
        <div
            class="flex w-11/12 rounded-br-[70px] bg-white/75 px-6 py-6 md:rounded-br-[150px] md:px-8 md:py-10 lg:w-9/12 xl:w-2/4 xl:py-16 xl:pl-[20%] xl:pr-8">
            <div class="container mx-auto">
                <h1
                    class="text-3.5xl font-medium uppercase leading-tight text-shrl-blue-500 xl:text-4.35xl">
                    {{ 'ABOUT_US.TITLE_SECTION.HEADING' | translate }}
                </h1>
                <div class="left text-base font-normal">
                    <p class="mb-4 mt-6 md:mt-8">
                        {{ 'ABOUT_US.TITLE_SECTION.PARAGRAPH_1' | translate }}
                    </p>
                    <p class="mb-8 mt-6 md:mb-10 md:mt-8">
                        {{ 'ABOUT_US.TITLE_SECTION.PARAGRAPH_2' | translate }}
                    </p>
                </div>

                <button mat-flat-button (click)="scrollTo(lockIntro)" class="">
                    {{ 'ABOUT_US.TITLE_SECTION.BUTTON' | translate }}
                </button>
            </div>
        </div>
    </section>
    <section class="pb-0 pt-12 md:py-12" #lockIntro>
        <div
            class="mx-auto w-full px-8 sm:max-w-lg md:max-w-3xl md:px-4 lg:max-w-4xl xl:max-w-6xl">
            <div class="border-b border-gray-400 pb-12">
                <div class="grid grid-cols-1 md:grid-cols-2">
                    <div>
                        <h2
                            class="mb-4 w-full text-3.5xl font-medium leading-tight text-shrl-blue-500 md:text-4.35xl xl:w-5/6">
                            {{ 'ABOUT_US.ABOUT.HEADING' | translate }}
                        </h2>
                        <p class="left my-10 w-full font-normal xl:w-5/6">
                            {{ 'ABOUT_US.ABOUT.PARAGRAPH' | translate }}
                        </p>
                    </div>
                    <div class="mt-4 md:mt-0 md:px-3.5">
                        <img
                            src="/assets/images/Sharelock_Product_Pic.webp"
                            alt="Door lock"
                            class="w-full" />
                    </div>
                </div>
            </div>
            <div class="mt-8 block xl:hidden">
                <swiper-container class="pb-20" shrlSwiper #swiper>
                    @for (card of INFORMATION_CARDS; track $index) {
                        <swiper-slide class="h-auto pb-14">
                            <div
                                class="mb-6 mt-2 h-full"
                                [ngClass]="{ 'pr-0 xl:pr-3.5': !$last }">
                                <div
                                    class="my-4 h-full rounded bg-white p-7 shadow-xl md:p-8">
                                    <h3
                                        class="mb-3 text-3xl font-medium md:mb-6 md:text-2xl"
                                        [ngClass]="card.color">
                                        {{ card.label + '.TITLE' | translate }}
                                    </h3>
                                    <p class="m-0">
                                        {{
                                            card.label + '.PARAGRAPH'
                                                | translate
                                        }}
                                    </p>
                                </div>
                            </div>
                        </swiper-slide>
                    }
                </swiper-container>
            </div>
            <div class="my-2 mt-12 hidden grid-cols-1 xl:grid xl:grid-cols-3">
                @for (card of INFORMATION_CARDS; track $index) {
                    <div class="my-2" [ngClass]="{ 'pr-0 xl:pr-3.5': !$last }">
                        <div class="my-4 h-full rounded bg-white p-8 shadow-xl">
                            <h4
                                class="mb-6 text-2xl font-medium"
                                [ngClass]="card.color">
                                {{ card.label + '.TITLE' | translate }}
                            </h4>
                            <p class="m-0">
                                {{ card.label + '.PARAGRAPH' | translate }}
                            </p>
                        </div>
                    </div>
                }
            </div>
        </div>
    </section>
    <section class="bg-white px-8 py-12 md:py-20">
        <div class="container mx-auto max-w-6xl px-4 md:px-8">
            <div class="mb-8 text-left">
                <h2
                    class="mb-4 text-3xl font-medium text-shrl-blue-500 lg:text-4xl">
                    {{ 'ABOUT_US.GUESTS_TESTIMONIALS.HEADING' | translate }}
                </h2>
                <p class="text-base text-gray-600 md:text-lg">
                    {{ 'ABOUT_US.GUESTS_TESTIMONIALS.SUBTITLE' | translate }}
                </p>
            </div>
            <shrl-image-carousel [items]="carouselItems"></shrl-image-carousel>
        </div>
    </section>
    <section class="bg-shrl-slate-100 pb-24 pt-12 text-center">
        <div
            class="container mx-auto max-w-lg text-center md:flex md:max-w-6xl md:flex-col md:items-center">
            <h2
                class="mb-12 px-8 py-8 text-3xl font-medium text-shrl-blue-500 xl:px-56 xl:text-4.35xl">
                {{ 'ABOUT_US.PACKAGES.HEADING_PACKAGES' | translate }} <br />
                {{ 'ABOUT_US.PACKAGES.HEADING_FAIR' | translate }}
            </h2>
            <div class="block max-w-lg xl:hidden">
                <swiper-container
                    shrlSwiper
                    [autoSlides]="true"
                    #swiper
                    (swiperslidechange)="slideChange($event)">
                    @for (subscriptionCard of SUBSCRIPTIONS; track $index) {
                        <swiper-slide class="!w-fit pb-12">
                            <div
                                class="center mx-3 my-auto rounded px-12"
                                [ngClass]="[
                                    'bg-' + subscriptionCard.bgColor,
                                    'text-' + subscriptionCard.color,
                                    $index ===
                                    subscriptionPackagesCarousel.currentIndex
                                        ? 'py-10 shadow-xl'
                                        : 'mt-4 py-6',
                                ]">
                                <h3 class="mb-4 text-2xl font-medium">
                                    {{
                                        subscriptionCard.label + '.TITLE'
                                            | translate
                                    }}
                                </h3>
                                <p
                                    class="mb-4 text-5xl font-normal"
                                    [ngClass]="
                                        'text-' + subscriptionCard.priceColor
                                    ">
                                    {{
                                        subscriptionCard.label + '.PRICE'
                                            | translate
                                    }}
                                </p>
                                <p class="shrl-text-h5">
                                    {{
                                        'ABOUT_US.PACKAGES.PLUS_23_VAT'
                                            | translate
                                    }}
                                </p>
                            </div>
                        </swiper-slide>
                    }
                </swiper-container>
            </div>
            <div
                class="hidden w-full grid-cols-1 justify-center xl:grid xl:w-9/12 xl:grid-cols-3">
                @for (subscriptionCard of SUBSCRIPTIONS; track $index) {
                    <div
                        class="mx-3 my-auto rounded px-4 shadow-xl"
                        [ngClass]="[
                            'bg-' + subscriptionCard.bgColor,
                            'text-' + subscriptionCard.color,
                            !$first && !$last ? 'py-10' : 'py-6',
                        ]">
                        <h4 class="mb-4 text-2xl font-medium">
                            {{ subscriptionCard.label + '.TITLE' | translate }}
                        </h4>
                        <p
                            class="mb-4 text-5xl font-normal"
                            [ngClass]="'text-' + subscriptionCard.priceColor">
                            {{ subscriptionCard.label + '.PRICE' | translate }}
                        </p>
                        <p class="shrl-text-h5">
                            {{ 'ABOUT_US.PACKAGES.PLUS_23_VAT' | translate }}
                        </p>
                    </div>
                }
            </div>
        </div>
    </section>
    <section
        class="flex flex-col justify-center bg-shrl-teal-500 px-0 pt-20 text-center xl:px-[30%]">
        <div
            class="container mx-auto flex w-full max-w-lg flex-col items-center px-8 md:max-w-6xl md:px-0">
            <h2
                class="mb-8 text-3.5xl font-medium text-shrl-neutral-900 md:text-4.35xl md:font-bold">
                {{ 'ABOUT_US.FIND_OUT_MORE.HEADING' | translate }}
            </h2>
            <button
                mat-flat-button
                [routerLink]="ENavigationRoute.HOW_IT_WORKS"
                class="">
                {{ 'SHARED.GENERAL.CLICK_HERE' | translate }}
            </button>
        </div>
        <img
            class="h-80 object-contain px-4 pt-8 md:px-0"
            src="/assets/images/Sharelock_Laptop.webp"
            alt="Section 3 Image" />
    </section>
</div>
